import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import TapSelect from "../../../components/ui/TapSelect";
import Loader from "../../../components/ui/Loader/Loader";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";

const AssetSCSSearchModal = forwardRef(({submitSearchFormProp}, ref) => {

    const assetSCSFormDataUrl   =   BACKOFFICE_BASE_URL + '/scs/form_data';
    const access_token          =   useSelector(state => state.auth.access_token);
    const modalElem             =   useRef(null);
    const searchModal           =   useRef(null);

    const initialSearching      =   {
        like_scs_name               :   '',
        search_status               :   '',
        search_section_ids          :   [],
        search_asset_type_ids       :   [],
    }

    const [assetSCSSearchForm, setAssetSCSSearchForm] = useState(initialSearching);

    const searchFormLabel   =   {
        like_scs_name           :   'Name : ',
        search_section_ids      :   'Sections : ',
        search_asset_type_ids   :   'Asset Types : ',
        search_status           :   'Status : '
    };

    const [formLoading, setFormLoading] =   useState(false);   
    const [formData, setFormData]       =   useState({
        assetType       :   [],
        sections        :   [],
        status          :   [],
    });

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            searchModal.current.show();
        },
        clearSearchForm: () => {
            setAssetSCSSearchForm(initialSearching);
        }
    }));

    useEffect(() => {
        if(formData.assetType.length <= 0 || formData.sections.length <= 0) {
            getAddFormData();
        }
        modalElem.current = document.getElementById("assetID");
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);


     const getAddFormData = () => {
        setFormLoading(true);
        HttpAPICall.withAthorization('GET', assetSCSFormDataUrl, access_token, {listing_form_data : 'Y'}, {}, (resp) => {
                const respData = resp.data;
                setFormData({
                    assetType : respData.asset_types.map(at => ({label : at.asset_type_name, value: at.id})),
                    sections  : respData.sections.map(s => ({label : s.component, value: s.id})),
                    status    : respData.status.map(s => ({label : s.status, value: s.key})),
                })
            }
        ).then(() =>  setFormLoading(false));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAssetSCSSearchForm(prev => ({ ...prev, [name]: value }));
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(assetSCSSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = assetSCSSearchForm[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'like_scs_name') {
                        show_val = assetSCSSearchForm ? assetSCSSearchForm.like_scs_name : '';
                    }
                    if (key == 'search_section_ids') {
                        show_val = formData.sections.filter(s => assetSCSSearchForm.search_section_ids.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_asset_type_ids') {
                        show_val = formData.assetType.filter(s => assetSCSSearchForm.search_asset_type_ids.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_status') {
                        show_val = formData.status.find(s => assetSCSSearchForm.search_status=== s.value)?.label;
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        submitSearchFormProp(searchedElems, assetSCSSearchForm);
        searchModal.current.hide();
    };

    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
    };

    const yesNoOptions = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' }
    ];

    return (
        <>
            <div className="modal fade" id={"assetID"} tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="employeeSearchModalLabel">Asset SCS Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={searchModalClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form id="assetSCSSearchForm" onSubmit={submitSearchForm}>
                                <div className="modal-body">
                                    {formLoading ? <Loader />
                                        : <>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Name</label>
                                                <div className="col-sm-10">
                                                    <input
                                                        name="like_scs_name"
                                                        type="text"
                                                        value={assetSCSSearchForm.like_scs_name}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={handleInputChange}
                                                        placeholder="Please enter Asset SCS Name"
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Asset Type</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={formData.assetType}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAssetSCSSearchForm(prev => ({ ...prev, search_asset_type_ids: selectedOption.map(s => s.value)}));
                                                            }
                                                        }}
                                                        value={formData.assetType.filter(u => assetSCSSearchForm.search_asset_type_ids.includes(u.value))}
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        isClearable={true}
                                                        placeholder="Select Asset Type"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Sections</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={formData.sections}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAssetSCSSearchForm(prev => ({ ...prev, search_section_ids: selectedOption.map(s => s.value)}));
                                                            }
                                                        }}
                                                        value={formData.sections.filter(u => assetSCSSearchForm.search_section_ids.includes(u.value))}
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        isClearable={true}
                                                        placeholder="Select Sections"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Status</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={formData.status}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAssetSCSSearchForm(prev => ({ ...prev, search_status: selectedOption.value}));
                                                            }
                                                        }}
                                                        value={formData.status.find(u => assetSCSSearchForm.search_status === u.value)}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select Status"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                        </>}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={searchModalClose} data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={formLoading} className="btn btn-primary">Search</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default AssetSCSSearchModal;
